import React from "react";
import { TeamRail, TeamAvatar, VoteCount, voteTargetClasses } from "./liveUi";

// Mirror of the web game master's "who answered" screen — layout copied from
// components/tarbaa/WhoAnswered.js, with the award buttons as vote targets.
const LiveWhoAnswered = ({ state, presence, voting }) => {
  const teams = state?.teams || [];

  const bigButton = (key, label, team) => {
    const mine = voting.myVote === key;
    const count = voting.counts?.[key] || 0;
    return (
      <button
        key={key}
        onClick={() => voting.tap("answer", key)}
        className={`relative w-1/3 h-1/4 p-2 xl:p-4 bg-secondaryButton rounded-2xl hover:bg-secondaryButtonShadow flex flex-row justify-center items-center ${voteTargetClasses(
          mine,
          voting.canVote
        )}`}
      >
        <VoteCount count={count} />
        <div className="w-1/4 h-full flex justify-center items-center">
          <div className="w-full aspect-square overflow-hidden rounded-full">
            {team ? (
              <TeamAvatar team={team} />
            ) : (
              <div className="w-full h-full bg-textBlackWhite flex items-center justify-center text-2xl">
                ؟
              </div>
            )}
          </div>
        </div>
        <div className="h-full w-3/4 text-sm md:text-xl xl:text-2xl font-bold flex justify-center items-center overflow-hidden">
          <h1 className="text-white text-center">{label}</h1>
        </div>
      </button>
    );
  };

  return (
    <div className="w-full h-[90vh] flex flex-col sm:flex-row pl-10 pr-2 py-10 xl:py-20">
      <div className="relative h-3/4 w-full sm:w-5/6 sm:h-full text-xl xl:text-3xl font-bold text-dark border-8 border-behindButton rounded-[50px]">
        <div className="h-full w-full flex justify-center items-center p-2 px-4 xl:px-10 text-white">
          <div className="flex-wrap flex justify-center items-center gap-4">
            {teams.map((team) => bigButton(`team:${team.id}`, team.name, team))}
            {bigButton("nobody", "محد جاوب", null)}
          </div>
        </div>

        {/* Back-to-answer vote — same corner as the master's الجواب button */}
        <div className="absolute bottom-0 transform -translate-x-1/2 translate-y-1/2 right-0 text-white rounded-lg text-sm xl:text-xl">
          <button
            onClick={() => voting.tap("answer", "back")}
            className={`relative bg-mainButton hover:bg-mainButtonShadow text-white font-bold py-3 px-4 md:px-10 border-b-8 border-mainButtonShadow rounded-md text-sm md:text-xl ${voteTargetClasses(
              voting.myVote === "back",
              voting.canVote
            )}`}
          >
            <VoteCount count={voting.counts?.back || 0} />
            الجواب
          </button>
        </div>
      </div>

      <TeamRail state={state} presence={presence} voting={voting} />
    </div>
  );
};

export default LiveWhoAnswered;
